import React from "react";
import { useSelector } from "react-redux";
import { Button } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { history } from "../../history";
import { getThemes, getUser } from "../../utility/Common";
import themeConfig from "../../configs/themeConfig.js";
import "./Style.scss";

const BuyNow = () => {
  const customizer = useSelector((state) => state.customizer);
  return (
    <div className="buy-now">
      {themeConfig.hideBuyButton === true ? (
        <div>
          {getUser().role !== "student" && (
            <div>
              {getUser().role === "admin" ? (
                <Button
                  className={`aligbotton ${customizer.customizer.menuTheme === "info" ||
                    customizer.customizer.menuTheme === "warning" ||
                    customizer.customizer.menuTheme === "secondary"
                    ? "ytextc"
                    : "white"
                    } bg-btn-dash-${customizer.customizer.menuTheme} dis-none`}
                  onClick={() => history.push("/panel/university/student-report")}
                >
                  <FormattedMessage id="Student Report" />
                </Button>
              ) : null}
              {getUser().role === "admin" || getUser().role === "manager" || getUser().role === "sub_manager" ? (
                <Button
                  className={`aligbotton ${customizer.customizer.menuTheme === "info" ||
                    customizer.customizer.menuTheme === "warning" ||
                    customizer.customizer.menuTheme === "secondary"
                    ? "ytextc"
                    : "white"
                    } bg-btn-dash-${customizer.customizer.menuTheme} dis-none`}
                  onClick={() => history.push("/panel/lecturer/online-exams")}
                >
                  <FormattedMessage id="inner_Exams_list" />
                </Button>
              ) : null}

              {getUser().role === "admin" ? (
                <Button
                  className={`aligbotton ${customizer.customizer.menuTheme === "info" ||
                    customizer.customizer.menuTheme === "warning" ||
                    customizer.customizer.menuTheme === "secondary"
                    ? "ytextc"
                    : "white"
                    } bg-btn-dash-${customizer.customizer.menuTheme} dis-none`}
                  onClick={() => history.push("/panel/university/student")}
                >
                  <FormattedMessage id="StudentsList" />
                </Button>
              ) : null}
              <Button
                className={`aligbotton ${customizer.customizer.menuTheme === "info" ||
                  customizer.customizer.menuTheme === "warning" ||
                  customizer.customizer.menuTheme === "secondary"
                  ? "ytextc"
                  : "white"
                  } bg-btn-dash-${customizer.customizer.menuTheme} dis-none`}
                onClick={() => history.push("/panel/university/subject")}
              >
                <FormattedMessage id="Subjects" />
              </Button>
              {getUser().role === "admin" ? (
                <Button
                  className={`aligbotton ${customizer.customizer.menuTheme === "info" ||
                    customizer.customizer.menuTheme === "warning" ||
                    customizer.customizer.menuTheme === "secondary"
                    ? "ytextc"
                    : "white"
                    } bg-btn-dash-${customizer.customizer.menuTheme} dis-none`}
                  onClick={() => history.push("/panel/university/student-housing")}
                >
                  <FormattedMessage id="Student Housing" />
                </Button>
              ) : null}
              {getUser().role === "admin" ? (
                <Button
                  className={`aligbotton ${customizer.customizer.menuTheme === "info" ||
                    customizer.customizer.menuTheme === "warning" ||
                    customizer.customizer.menuTheme === "secondary"
                    ? "ytextc"
                    : "white"
                    } bg-btn-dash-${customizer.customizer.menuTheme} dis-none`}
                  onClick={() => history.push("/panel/university/study-year")}
                >
                  <FormattedMessage id="Study Year" />
                </Button>
              ) : null}
            </div>
          )}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};

export default BuyNow;
